import { Breadcrumbs, Anchor, createStyles, ScrollArea } from '@mantine/core';
import withRouter from '../../utility/react-router-dom/witrouter-compo';
const useStyles = createStyles((theme) => ({
  scrollarea: {
    marginTop: 0,
    marginBottom: 25,
    '@media (max-width: 600px)': {
      marginTop: 0,
    },
  },
  breadcrumbs: {
    backgroundColor: '#F2CD00',
    height: 70,
  },
  textAnchor: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 400,
    fontSize: 16,
    color: '#000000',
  },
  pembungkusAnchor: {
    background: '#F2CD00',
    paddingLeft: 20,
    transition: '0.5s',
    '@media (min-width: 600px)': {
      paddingLeft: 100,
      transition: '0.5s',
    },
    '@media (min-width: 1200px)': {
      paddingLeft: 250,
      transition: '0.5s',
    },
    '@media (min-width: 1600px)': {
      paddingLeft: 400,
      transition: '0.5s',
    },
  },
}));

const BreadCrumb2Compo = (props) => {
  const { classes } = useStyles();
  const {
    navigate,
    location: { pathname },
  } = props.router;
  const pathnames = pathname.split('/').filter((x) => x);
  console.log(pathnames);

  console.group(navigate);
  console.groupEnd(navigate);
  return (
    <>
      <ScrollArea className={classes.scrollarea}>
        <div className={classes.linkBreadcrumbs}>
          <div className={classes.pembungkusAnchor}>
            <Breadcrumbs separator=">" className={classes.breadcrumbs}>
              <Anchor
                onClick={() => navigate('/')}
                className={classes.textAnchor}
              >
                Beranda
              </Anchor>
              {pathnames.map((name, index) => {
                const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                const title =
                  name[0].toUpperCase() +
                  name.substring(1).replaceAll('-', ' ');
                const isLast = index === pathnames.length - 1;
                return (
                  <Anchor
                  key={index}
                    onClick={() => navigate(routeTo)}
                    className={classes.textAnchor}
                  >
                    {title}{' '}
                  </Anchor>
                );
              })}
            </Breadcrumbs>
          </div>
        </div>
      </ScrollArea>
    </>
  );
};

export default withRouter(BreadCrumb2Compo);
